import { render } from "./PrevPageLink.vue?vue&type=template&id=6b167256"
import script from "./PrevPageLink.vue?vue&type=script&lang=js"
export * from "./PrevPageLink.vue?vue&type=script&lang=js"
script.render = render

export default script